import {
  DataResourceDetail,
  DataResourceDetailRequirement,
  EngagementStatusBlock,
  EngagementTaskTrait,
  ResourceDataType,
  TaskDataResponse,
  TaskDataTraitStatus,
  TaskFieldDetails,
} from '@cibo/core'
import { propEq } from 'ramda'

export type TASK_DETAIL_KEY_NAME = 'userDetails' | 'wfDetails' | 'fieldDetails'

export const TASK_DETAIL_KEY: Record<ResourceDataType, TASK_DETAIL_KEY_NAME> = {
  user: 'userDetails',
  workflow: 'wfDetails',
  field: 'fieldDetails',
}

export class TaskDataModel
  implements
    Pick<
      TaskDataResponse,
      'detailRequirements' | 'status' | 'fieldDetails' | 'userDetails' | 'wfDetails'
    >
{
  detailRequirements: DataResourceDetailRequirement[]
  status: EngagementStatusBlock

  fieldDetails?: TaskFieldDetails[]
  userDetails?: DataResourceDetail[]
  wfDetails?: DataResourceDetail[]

  traits?: TaskDataTraitStatus[]

  constructor(data: TaskDataResponse) {
    this.detailRequirements = data.detailRequirements
    this.status = data.status
    this.fieldDetails = data.fieldDetails
    this.userDetails = data.userDetails
    this.wfDetails = data.wfDetails
    this.traits = data.traits
  }

  getDetail(traitConfig: EngagementTaskTrait, resourceId?: string) {
    const taskDataTypeDetails = this[TASK_DETAIL_KEY[traitConfig.dataType]]

    return traitConfig.dataType === 'field'
      ? (taskDataTypeDetails as TaskFieldDetails[])
          ?.find(propEq('resourceId', resourceId))
          ?.details?.find(propEq('traitId', traitConfig.traitId))
      : (taskDataTypeDetails as DataResourceDetail[])?.find(propEq('traitId', traitConfig.traitId))
  }

  getDetailValue(traitConfig: EngagementTaskTrait, resourceId?: string) {
    const detail = this.getDetail(traitConfig, resourceId)

    if (!detail) return undefined

    return traitConfig.dataType === 'field' ? detail.result : detail.value
  }

  getTraitStatus(traitId: string): TaskDataTraitStatus | undefined {
    return this.traits?.find(propEq('traitId', traitId))
  }
}
